import { createStore as vuexCreateStore } from "vuex";
import moduleUser from "./user/moduleUser";
import moduleToken from "./token/moduleToken";
import modulePermissions from "./permissions/modulePermissions";
import moduleAudiences from "./audiences/moduleAudiences";
import moduleEngagement from "./engagement/moduleEngagement";
import moduleDate from "./date/moduleDate";
import moduleBemax from "./bemax/moduleBemax";
import moduleAlerts from "./alerts/moduleAlerts";
import moduleLoading from "./loading/moduleLoading";
import moduleTheme from "./theme/moduleTheme";
import moduleCampaign from "./campaign/moduleCampaign";
import moduleCampaignSms from "./campaign/sms/moduleCampaignSms";
import moduleWorkflow from "./workflow/moduleWorkflow";
import moduleImports from "./imports/moduleImports";

const allModules = {
  user: moduleUser,
  token: moduleToken,
  permissions: modulePermissions,
  audiences: moduleAudiences,
  engagement: moduleEngagement,
  date: moduleDate,
  bemax: moduleBemax,
  alerts: moduleAlerts,
  loading: moduleLoading,
  theme: moduleTheme,
  campaign: moduleCampaign,
  campaignSms: moduleCampaignSms,
  workflow: moduleWorkflow,
  imports: moduleImports,
};

type IKeysAllModules = keyof typeof allModules;
type IModule = {
  [key in IKeysAllModules]?: { state: any };
};

export const createStore = (newStates?: IModule) => {
  if (newStates) {
    Reflect.ownKeys(newStates).forEach((el) => {
      allModules[el].state = {
        ...allModules[el].state,
        ...newStates[el].state,
      };
    });
  }

  return vuexCreateStore({
    state: {},
    mutations: {},
    actions: {},
    modules: {
      ...allModules,
    },
  });
};

export default createStore();
